import { FC, useMemo } from "react";
import { JobTypes } from "../../../../Core/Api/Types/job-types";
import { FormControlLabel, Grid, Switch } from "@mui/material";
import React from "react";
import { DbJobRuleInfos } from "../../../../Core/Api/Types/db-job-rule-infos";
import FormInputText from "../../../../Components/Forms/FormInputText/form-input-text";
import FormAutocomplete from "../../../../Components/Forms/FormAutocomplete/form-autocomplete";
import { produce } from "immer";
import FormInputNumber from "../../../../Components/Forms/FormInputNumber/form-input-number";
import { EZConvertFormat } from "../../../../Core/Api/Types/ez-convert-format";
import FormSection from "../../../../Components/Forms/FormSection/form-section";
import GradeIcon from "@mui/icons-material/Grade";
import {
  JobArchiveDiva,
  AtmosRendererLogLevel,
  AtmosRendererOutputFileType,
  JobAudioAtmosRenderer,
  JobAudioLanguageDetection,
  JobAudioWaveformGenerate,
  JobAuthotSpeechToText,
  JobConvertSubtitle,
  JobExecuteCommandAmberfin,
  JobFileAsperaTransferServerToServerAmberfin,
  JobFileCopyAmberfin,
  JobConvertImage,
  JobFileCompress,
  JobLiquidExport,
  JobQcBatonVerifyFile,
  JobTranscodeByTemplateAmberfin,
  JobTranscodeUsingFFmpeg,
  WhisperModels,
  JobWhisperSpeechToText,
  JobFileAsperaTransferServerToServer,
  FFmpegVersion,
} from "../../../../Core/Api/Types/job-base-infos";
import { CompressFormat } from "../../../../Core/Api/Types/compress-format";
import { TranskodeWrapper } from "../../../../Core/Api/Types/transkode-wrapper";
import GlobalConst from "../../../../Core/Utils/Constants/globals";
import { useTranslation } from "react-i18next";

export type JobDefEditSpecialParamsProps = {
  newJobRule: DbJobRuleInfos;
  selectedJobDefRow: number;
  setNewJobRule: React.Dispatch<React.SetStateAction<DbJobRuleInfos | null>>;
  formId: string;
};

const JobDefEditSpecialParams: FC<JobDefEditSpecialParamsProps> = (props) => {
  const { t } = useTranslation();
  const { newJobRule, selectedJobDefRow, setNewJobRule, formId } = props;

  const renderSpecialParamsSetup = useMemo(() => {
    if (!newJobRule.jobsDefinitions) return <></>;
    switch (newJobRule.jobsDefinitions[selectedJobDefRow].type) {
      case JobTypes.TranscodeByTemplateAmberfin:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("field:label.amberFinTemplate")}
                fullWidth={true}
                value={
                  (newJobRule.jobsDefinitions![selectedJobDefRow]!.jobInfo as JobTranscodeByTemplateAmberfin)!.template
                }
                placeholder={t("field:placeholder.amberFInTemplate")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      draft!.jobsDefinitions = draft!.jobsDefinitions!.map((x, i) =>
                        i === selectedJobDefRow ? { ...x, jobInfo: { ...x.jobInfo!, template: v.target.value } } : x
                      );
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAmberConv-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid!}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions![selectedJobDefRow]!.jobInfo as JobTranscodeByTemplateAmberfin)!
                      .template ?? undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("field:label.amberFinConversion")}
                fullWidth={true}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobTranscodeByTemplateAmberfin)!.conversion
                }
                placeholder={t("field:placeholder.amberFInConversion")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobTranscodeByTemplateAmberfin)!.conversion = v.target.value;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAmberTemp-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid!}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobTranscodeByTemplateAmberfin)!
                      .conversion ?? undefined,
                }}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.AuthotSpeechToText:
        return (
          <Grid container spacing={2}>
            <Grid item md={4} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAuthotSpeechToText)?.humanCheck ||
                      false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAuthotSpeechToText)!.humanCheck =
                            v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.correction")}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAuthotSpeechToText)?.creditCheck ||
                      false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAuthotSpeechToText)!.creditCheck =
                            v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.creditCheck")}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAuthotSpeechToText)
                        ?.analyzeAudioLanguageIfNotFound || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobAuthotSpeechToText)!.analyzeAudioLanguageIfNotFound = v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.analyzeAudioLanguageIfNotFound")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.WhisperSpeechToText:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectWhisperModel")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobWhisperSpeechToText)?.whisperModel}
                fullWidth
                options={Object.values(WhisperModels)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobWhisperSpeechToText)!.whisperModel = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefWhisperSpeechToText-whisperModel-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.AudioWaveformGenerate:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioWaveformGenerate)?.zoom}
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefaudioWavGen-zoom-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioWaveformGenerate)?.zoom ??
                    undefined,
                }}
                label={t("field:label.zoom")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAudioWaveformGenerate)!.zoom = parseInt(
                        v.target.value
                      );
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioWaveformGenerate)?.bits}
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefaudioWavGen-bits-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioWaveformGenerate)?.bits ??
                    undefined,
                }}
                label={t("field:label.bits")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAudioWaveformGenerate)!.bits = parseInt(
                        v.target.value
                      );
                    })
                  )
                }
              />
            </Grid>
          </Grid>
        );
      case JobTypes.ArchiveDiva:
        return (
          <Grid item md={6} sm={12} xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobArchiveDiva)?.deleteSource || false
                  }
                  onChange={(v) =>
                    setNewJobRule(
                      produce((draft) => {
                        (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobArchiveDiva)!.deleteSource =
                          v.target.checked;
                      })
                    )
                  }
                />
              }
              label={t("field:label.deleteSourceFileCaution")}
            />
          </Grid>
        );
      case JobTypes.TranscodeUsingFFmpeg:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("common:arguments")}
                fullWidth={true}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobTranscodeUsingFFmpeg)!.args}
                placeholder={t("common:arguments")}
                onChange={(v) => {
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)!.args =
                        v.target.value;
                    })
                  );
                }}
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDeftranscodeFFmpeg-args-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobTranscodeUsingFFmpeg)!.args ??
                    undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)?.exitCodeExpected
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDeftranscodeFFmpeg-exit-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)
                      ?.exitCodeExpected ?? undefined,
                }}
                label={t("field:label.expectedExitCode")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobTranscodeUsingFFmpeg)!.exitCodeExpected = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)?.timeOut}
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDeftranscodeFFmpeg-timeout-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)?.timeOut ??
                    undefined,
                }}
                label={t("field:label.timeoutMs")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)!.timeOut = v
                        .target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectFFmpegVersion")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)?.version}
                fullWidth
                options={Object.values(FFmpegVersion)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)!.version = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefJobTranscodeUsingFFmpeg-ffversion-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)?.parseMedia ||
                      false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)!.parseMedia =
                            v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.parseMedia")}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)?.parseThumbs ||
                      false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)!.parseThumbs =
                            v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.parseThumbnails")}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobTranscodeUsingFFmpeg)
                        ?.parseSceneDetect || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobTranscodeUsingFFmpeg)!.parseSceneDetect = v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.parseSceneDetection")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.AudioLanguageDetection:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)
                    ?.classifierProcessEveryNth
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioLanguageDetection-classifierProcessEveryNth-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)
                      ?.classifierProcessEveryNth ?? undefined,
                  minValue: 1,
                }}
                label={t("field:label.classifierProcessEveryNSamples")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobAudioLanguageDetection)!.classifierProcessEveryNth = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)?.topNthLanguages
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioLanguageDetection-topNthLanguages-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)
                      ?.topNthLanguages ?? undefined,
                  minValue: 1,
                }}
                label={t("field:label.retrieveDetectedLanguages")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobAudioLanguageDetection)!.topNthLanguages = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectWhisperModel")}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)?.whisperModel
                }
                fullWidth
                options={Object.values(WhisperModels)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAudioLanguageDetection)!.whisperModel =
                        v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioLanguageDetection-whisperModel-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("field:label.vadThreshold")}
                fullWidth={true}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)?.vadTreshold
                }
                placeholder={t("field:placeholder.whisperModelPath")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAudioLanguageDetection)!.vadTreshold =
                        Number(v.target.value);
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioLanguageDetection-vadTreshold-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)
                        ?.vadUseOnnx || false
                    }
                    onChange={(e) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobAudioLanguageDetection)!.vadUseOnnx = e.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.useOnnxForVad")}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)
                        ?.setAudioChannelsLanguagePostAction || false
                    }
                    onChange={(e) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobAudioLanguageDetection)!.setAudioChannelsLanguagePostAction =
                            e.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.setAudioChannelsLanguage")}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioLanguageDetection)
                        ?.setAudioMainLanguagePostAction || false
                    }
                    onChange={(e) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobAudioLanguageDetection)!.setAudioMainLanguagePostAction = e.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.setMainAudioLanguageMetadata")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.ExecuteCommandAmberfin:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("common:executablePath")}
                fullWidth={true}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobExecuteCommandAmberfin)!.exePath}
                placeholder={t("common:executablePath")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobExecuteCommandAmberfin)!.exePath =
                        v.target.value;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefexecCom-exepath-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobExecuteCommandAmberfin)!.exePath ??
                    undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobExecuteCommandAmberfin)?.exitCodeExpected
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefexecCom-exit-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobExecuteCommandAmberfin)
                      ?.exitCodeExpected ?? undefined,
                }}
                label={t("field:label.expectedExitCode")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobExecuteCommandAmberfin)!.exitCodeExpected = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobExecuteCommandAmberfin)?.timeOut}
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefexecCom-timeout-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobExecuteCommandAmberfin)?.timeOut ??
                    undefined,
                }}
                label={t("field:label.timeoutMs")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobExecuteCommandAmberfin)!.timeOut = v
                        .target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
          </Grid>
        );
      case JobTypes.FileAsperaTransferServerToServerAmberfin:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.direction")}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServerAmberfin)
                    ?.direction
                }
                fullWidth
                options={["Push"]}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin)!.direction = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-direction-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (
                      newJobRule.jobsDefinitions[selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin
                    )?.direction ?? undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.transferMode")}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServerAmberfin)
                    ?.transferMode
                }
                fullWidth
                options={["Fair", "Fixed", "Trickle"]}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin)!.transferMode = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-transferMode-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (
                      newJobRule.jobsDefinitions[selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin
                    )?.transferMode ?? undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServerAmberfin)
                    ?.transferRateKbps
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-transferRate-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (
                      newJobRule.jobsDefinitions[selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin
                    )?.transferRateKbps ?? undefined,
                }}
                label={t("field:label.transferRate")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin)!.transferRateKbps = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServerAmberfin)
                    ?.timeoutMin
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-timeoutmin-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (
                      newJobRule.jobsDefinitions[selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin
                    )?.timeoutMin ?? undefined,
                }}
                label={t("field:label.timeoutMinutes")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServerAmberfin)!.timeoutMin = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (
                        newJobRule.jobsDefinitions[selectedJobDefRow]
                          .jobInfo as JobFileAsperaTransferServerToServerAmberfin
                      )?.overwrite || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobFileAsperaTransferServerToServerAmberfin)!.overwrite = v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.overwrite")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.FileAsperaTransferServerToServer:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.direction")}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                    ?.direction
                }
                fullWidth
                options={["Push"]}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServer)!.direction = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-direction-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                      ?.direction ?? undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.transferMode")}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                    ?.transferMode
                }
                fullWidth
                options={["Fair", "Fixed", "Trickle"]}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServer)!.transferMode = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-transferMode-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                      ?.transferMode ?? undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                    ?.transferRateKbps
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-transferRate-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                      ?.transferRateKbps ?? undefined,
                }}
                label={t("field:label.transferRate")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServer)!.transferRateKbps = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputNumber
                stackProps={{}}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                    ?.timeoutMin
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-timeoutmin-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                      ?.timeoutMin ?? undefined,
                }}
                label={t("field:label.timeoutMinutes")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobFileAsperaTransferServerToServer)!.timeoutMin = v.target.value
                        ? parseInt(v.target.value)
                        : undefined;
                    })
                  )
                }
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                sx={{ mt: 2 }}
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileAsperaTransferServerToServer)
                        ?.overwrite || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobFileAsperaTransferServerToServer)!.overwrite = v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.overwrite")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.FileCopyAmberfin:
      case JobTypes.FileCopyInternalAsync:
        return (
          <Grid container>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileCopyAmberfin)
                        ?.deleteSourceOnSuccess || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobFileCopyAmberfin)!.deleteSourceOnSuccess = v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.deleteSourceFileCautionWithSpace")}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileCopyAmberfin)
                        ?.takeCareLinkedFiles || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow]
                            .jobInfo as JobFileCopyAmberfin)!.takeCareLinkedFiles = v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.takeCareLinkedFilesCaution")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.ConvertSubtitle:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.outputFormat")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertSubtitle)?.format}
                fullWidth
                options={Object.values(EZConvertFormat)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobConvertSubtitle)!.format = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-outputformat-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertSubtitle)?.format ?? undefined,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.outputFrameRate")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertSubtitle)?.outputFrameRate}
                fullWidth
                options={[23.98, 24, 25, 29.97]}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobConvertSubtitle)!.outputFrameRate = v
                        ? parseFloat(v)
                        : undefined;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-outputframerate-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid}`,
                  required: false,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("field:label.configFilePath")}
                fullWidth={true}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow]!.jobInfo as JobConvertSubtitle)!.configFilePath}
                placeholder={t("common:executablePath")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobConvertSubtitle)!.configFilePath =
                        v.target.value;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-configFilePath-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.configFileType")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertSubtitle)?.configFileType}
                fullWidth
                options={["Streaming", "Conversion"]}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobConvertSubtitle)!.configFileType = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-configFileType-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.FileLiquidMetadataExport:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("field:label.liquidTemplateName")}
                fullWidth={true}
                value={(newJobRule.jobsDefinitions![selectedJobDefRow]!.jobInfo as JobLiquidExport)!.templateName}
                placeholder={t("field:label.liquidTemplateName")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      draft!.jobsDefinitions = draft!.jobsDefinitions!.map((x, i) =>
                        i === selectedJobDefRow ? { ...x, jobInfo: { ...x.jobInfo!, templateName: v.target.value } } : x
                      );
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-configTamplateName-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid!}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions![selectedJobDefRow]!.jobInfo as JobLiquidExport)!.liquidTemplate ??
                    undefined,
                }}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.QcVerifyFileBaton:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={12} xs={12}>
              <FormInputText
                label={t("field:label.batonTestPlanName")}
                fullWidth={true}
                value={(newJobRule.jobsDefinitions![selectedJobDefRow]!.jobInfo as JobQcBatonVerifyFile)!.testPlan}
                placeholder={t("field:placeholder.testPlanName")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      draft!.jobsDefinitions = draft!.jobsDefinitions!.map((x, i) =>
                        i === selectedJobDefRow ? { ...x, jobInfo: { ...x.jobInfo!, testPlan: v.target.value } } : x
                      );
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-testplan-${newJobRule.jobsDefinitions[selectedJobDefRow].uuid!}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions![selectedJobDefRow]!.jobInfo as JobQcBatonVerifyFile)!.testPlan ??
                    undefined,
                }}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.FileCompress:
        return (
          <Grid container spacing={2}>
            <Grid item md={12} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectCompressFormat")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileCompress)?.compressFormat}
                fullWidth
                options={Object.values(CompressFormat)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobFileCompress)!.compressFormat = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-configFileCompressFormat-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileCompress)?.parseResult || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobFileCompress)!.parseResult =
                            v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.parseMedia")}
              />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobFileCompress)?.deleteSource || false
                    }
                    onChange={(v) =>
                      setNewJobRule(
                        produce((draft) => {
                          (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobFileCompress)!.deleteSource =
                            v.target.checked;
                        })
                      )
                    }
                  />
                }
                label={t("field:label.deleteSourceFileCautionWithSpace")}
              />
            </Grid>
          </Grid>
        );
      case JobTypes.ConvertImage:
        return (
          <Grid container spacing={2}>
            <Grid item md={6} sm={6} xs={6}>
              <FormAutocomplete
                label={t("field:label.selectOutputFormat")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertImage)?.codec}
                fullWidth
                options={Object.values(TranskodeWrapper)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobConvertImage)!.codec = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-configConvertFormat-${selectedJobDefRow}`,
                  required: false,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={6} sm={6} xs={6}>
              <FormInputNumber
                stackProps={{}}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertImage)?.quality}
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDef-configConvertFormat-${selectedJobDefRow}`,
                  required: true,
                  initialValue:
                    (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobConvertImage)?.quality ?? 100,
                }}
                label={t("field:label.qualityWithOneHundredIsTheBest")}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobConvertImage)!.quality = v.target.value
                        ? parseInt(v.target.value)
                        : 100;
                    })
                  )
                }
              />
            </Grid>
          </Grid>
        );
      case JobTypes.AudioAtmosRenderer: {
        return (
          <Grid container spacing={2}>
            <Grid item md={4} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectOutputAudioMix")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioAtmosRenderer)?.outputAudioMix}
                fullWidth
                options={GlobalConst.ATMOS_RENDERER_ALLOWED_AUDIO_MIXES}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAudioAtmosRenderer)!.outputAudioMix = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioAtmosRenderer-outputAudioMix-${selectedJobDefRow}`,
                  required: true,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectOutputFileType")}
                value={(newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioAtmosRenderer)?.outputFileType}
                fullWidth
                options={Object.values(AtmosRendererOutputFileType)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow].jobInfo as JobAudioAtmosRenderer)!.outputFileType = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioAtmosRenderer-outputFileType-${selectedJobDefRow}`,
                  required: true,
                  initialState: false,
                }}
              />
            </Grid>
            <Grid item md={4} sm={12} xs={12}>
              <FormAutocomplete
                label={t("field:label.selectAtmosRendererLogLevel")}
                value={
                  (newJobRule.jobsDefinitions[selectedJobDefRow].jobInfo as JobAudioAtmosRenderer)
                    ?.atmosRendererLogLevel
                }
                fullWidth
                options={Object.values(AtmosRendererLogLevel)}
                onChange={(v) =>
                  setNewJobRule(
                    produce((draft) => {
                      (draft!.jobsDefinitions![selectedJobDefRow]
                        .jobInfo as JobAudioAtmosRenderer)!.atmosRendererLogLevel = v;
                    })
                  )
                }
                validationProps={{
                  formId: formId,
                  formSectionId: newJobRule.jobsDefinitions[selectedJobDefRow].uuid!,
                  fieldId: `jobDefAudioAtmosRenderer-atmosRendererLogLevel-${selectedJobDefRow}`,
                  required: true,
                  initialState: false,
                }}
              />
            </Grid>
          </Grid>
        );
      }
      default:
        return <></>;
    }
  }, [newJobRule, selectedJobDefRow, newJobRule!.jobsDefinitions![selectedJobDefRow]]);

  return (
    <FormSection
      title={t("form:section.title.parametersSetup", { type: newJobRule.jobsDefinitions![selectedJobDefRow].type })}
      icon={<GradeIcon />}
      defaultExpanded={true}
      size="small"
    >
      {renderSpecialParamsSetup}
    </FormSection>
  );
};

export default JobDefEditSpecialParams;
